import {
  ApartmentOutlined,
  AppstoreOutlined,
  AuditOutlined,
  DeleteOutlined,
  ShopOutlined,
  ShoppingCartOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import React, { ReactElement } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { isAllowedService } from "../../../utils/services";

const ShopSidebar = ({ shopId }): ReactElement => {
  const pathname = window.location?.pathname;
  const { shopInfo } = useSelector((state) => (state as any)?.authReducer);

  return (
    <>
      <div className="h-100 product-details-wrapper-content">
        <div className="aside-menu">
          <Menu defaultSelectedKeys={["0"]} mode="inline">
            <Menu.Item
              key="/details"
              className={
                pathname.includes(`shops/${shopId}/details`) ? "active" : ""
              }
              icon={<ShopOutlined />}
            >
              <Link to={`/shops/${shopId}/details`}>Shop Information</Link>
            </Menu.Item>

            {isAllowedService(`Order List`) && (
              <Menu.Item
                key="/orders"
                icon={<ShoppingCartOutlined />}
                className={pathname.includes("/orders") ? "active" : ""}
              >
                <Link to={`/shops/${shopId}/orders`}>Order Management</Link>
              </Menu.Item>
            )}

            {shopInfo?.type !== "JC_MART" && (
              <Menu.Item
                key="/categories"
                icon={<ApartmentOutlined />}
                className={pathname.includes("/categories") ? "active" : ""}
              >
                <Link to={`/shops/${shopId}/categories`}>
                  Category Management
                </Link>
              </Menu.Item>
            )}

            <Menu.Item
              key="/products"
              icon={<AppstoreOutlined />}
              className={pathname.includes("/products") ? "active" : ""}
            >
              <Link to={`/shops/${shopId}/products`}>Product Management</Link>
            </Menu.Item>

            <Menu.Item
              key="/out-of-stock"
              icon={<AppstoreOutlined />}
              className={pathname.includes("/out-of-stock") ? "active" : ""}
            >
              <Link to={`/shops/${shopId}/out-of-stock`}>Out of Stock</Link>
            </Menu.Item>
            <Menu.Item
              key="/campaigns"
              icon={<AppstoreOutlined />}
              className={pathname.includes("/campaigns") ? "active" : ""}
            >
              <Link to={`/shops/${shopId}/campaigns`}>Campaign</Link>
            </Menu.Item>
            <Menu.Item
              key="/brands"
              icon={<AppstoreOutlined />}
              className={pathname.includes("/brands") ? "active" : ""}
            >
              <Link to={`/shops/${shopId}/brands`}>Brand</Link>
            </Menu.Item>
            <Menu.Item
              key="/transactions"
              icon={<AuditOutlined />}
              className={pathname.includes("/transactions") ? "active" : ""}
            >
              <Link to={`/shops/${shopId}/transactions`}>
                Transaction History
              </Link>
            </Menu.Item>

            <Menu.Item
              key="/sales-man"
              icon={<UserOutlined />}
              className={pathname.includes("/sales-man") ? "active" : ""}
            >
              <Link to={`/shops/${shopId}/sales-man`}>Sales Man List</Link>
            </Menu.Item>

            <Menu.Item
              key="/suppliers"
              icon={<UserOutlined />}
              className={pathname.includes("/suppliers") ? "active" : ""}
            >
              <Link to={`/shops/${shopId}/suppliers`}>Suppliers</Link>
            </Menu.Item>

            <Menu.Item
              key="/recycle-bin"
              icon={<DeleteOutlined />}
              className={pathname.includes("/recycle-bin") ? "active" : ""}
            >
              <Link to={`/shops/${shopId}/recycle-bin`}>Recycle Bin</Link>
            </Menu.Item>
          </Menu>
        </div>
      </div>
    </>
  );
};

export default ShopSidebar;
